import { useState, useEffect, SetStateAction, Dispatch } from 'react';
import { getVendorDocuments, VendorDocumentDTO } from 'wisestep-api';

const useVendorFilesByVendorId = (
  vendorId: string,
  refresh: boolean,
  setLoader: Dispatch<SetStateAction<boolean>>
) => {
  const [files, setFiles] = useState<VendorDocumentDTO[]>([]);

  useEffect(() => {
    const fetchFiles = async () => {
      setLoader(true);
      const response = await getVendorDocuments(vendorId);
      setFiles(response.data);
      setLoader(false);
    };
    fetchFiles();
  }, [vendorId, refresh, setLoader]);

  return files;
};
export default useVendorFilesByVendorId;
